<template>
  <ul class="live-list" v-if="liveList">
    <li v-for="(live, i) in liveList" :key="i">
      <live-card v-bind="live" />
    </li>
  </ul>
</template>

<script>
import LiveCard from '../organisms/LiveCard';

export default {
  components: {
    LiveCard,
  },
  computed: {
    liveList() {
      return this.$store.getters['live/liveList'];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../constants/style';

.live-list {
  align-items: stretch;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  list-style: none;
  margin: 0 -12px;

  & > li {
    flex: 0 0 408px;
    margin: 0 12px;
  }
  & > li > * + * {
    margin-right: auto;
    margin-left: auto;
  }

  @media #{$mq-sp} {
    display: block;

    &::before,
    &::after {
      min-width: auto;
    }
    & > li {
      min-width: auto;
      flex: 0 1 400px;
      padding: 0;

      &:not(:last-child) {
        margin-bottom: 32px;
      }
    }
  }
}
</style>
